import { 
  API_BASE, 
  MAIL_KEY, 
  PASS_KEY,
  STATUS_FAILURE_NO_TARGET, 
  STATUS_FAILURE_NOT_AUTHORIZED, 
  STATUS_FAILURE_ILLEGAL_REQUEST, 
  STATUS_FAILURE_NOT_AUTHORIZED_DEMO, 
  STATUS_ERROR_INTERNAL, 
  STATUS_FAILURE_TOP_EXISTSOWNER 
} from '@common/constant';

import { Ajax, FETCH_AFTER, FETCH_BEFORE, IO_ERROR } from '@common/lib/ajax';
import store from '../store';
import { getURLParameters } from '@common/util';
import route from 'riot-route';

const ajax = new Ajax(`${API_BASE}/top`);

const errorHandler = (e) => {
  if (e.status == null) {
    throw e;
  }

  switch (e.status) {
    case STATUS_FAILURE_ILLEGAL_REQUEST:
      showFailedDailog('不正なリクエストです。');
      break;

    case STATUS_FAILURE_NOT_AUTHORIZED_DEMO:
      showFailedDailog('デモ版では更新を伴う操作はできません。');
      break;

    case STATUS_ERROR_INTERNAL:
      showFailedDailog('サーバエラーです。');
      break;

    case IO_ERROR:
      showFailedDailog('ネットワークエラーが発生しました。ページを再度読み込んでください。');
      break;
      
    default:
      showFailedDailog('エラーが発生しました。エラーコード：' + e.status);
      break;
  }
};

ajax.on(FETCH_BEFORE, () => store.setLoading(true));
ajax.on(FETCH_AFTER, () => store.setLoading(false));

export const login = ({ mail, password, saveInputCheck }) => {
  ajax.post('/login', {
    method: 'login',
    mail,
    password
  })
    .then(res => {
      if (saveInputCheck) {
        localStorage.setItem(MAIL_KEY, btoa(mail));
        localStorage.setItem(PASS_KEY, btoa(password));
      } else {
        localStorage.removeItem(MAIL_KEY);
        localStorage.removeItem(PASS_KEY);
      }

      const redirectUrl = getURLParameters(location.search).redirect;
      if (res.isAdmin) {
        if (redirectUrl && decodeURIComponent(redirectUrl).indexOf('/admin#') != -1) {
          location.href = decodeURIComponent(redirectUrl);
        } else {
          location.href = '/admin';
        }
      } else if (redirectUrl && decodeURIComponent(redirectUrl).indexOf('/admin#') == -1) {
        location.href = `${decodeURIComponent(redirectUrl)}`;
      } else {
        location.href = '/owner';
      }
    })
    .catch(err => {
      if (err.status == STATUS_FAILURE_NOT_AUTHORIZED
        || err.status == STATUS_FAILURE_ILLEGAL_REQUEST) {
        showDialog({
          message: 'メールアドレスまたはパスワードが間違っています。',
          status: 'failed'
        });
        return;
      }
      errorHandler(err);
    });
}

export const changePassRequest = ({ mail }) => {
  ajax.post('/password', {
    method: 'changeRequest',
    mail
  })
    .then(res => {
      route('password/complete');
    })
    .catch(err => {
      if (err.status == STATUS_FAILURE_NO_TARGET) {
        showDialog({
          message: '失敗しました。\nメールアドレスが存在しません。',
          status: 'failed'
        });
        return;
      }
      errorHandler(err);
    });
}

export const checkChangePass = ({ key }) => {
  return ajax.post('/password', {
    method: 'changeUrl',
    key
  })
    .catch(err => {
      if (err.status == STATUS_FAILURE_NO_TARGET) {
        showDialog({
          message: 'urlが使用済みです。',
          status: 'failed'
        });
        return;
      }
      errorHandler(err);
    });
}

export const changePass = ({ password, key }) => {
  ajax.post('/password', {
    method: 'changeUrl',
    password,
    key
  })
    .then(res => {
      showDialog({
        message: 'パスワードを変更しました。',
        status: 'success'
      });
      route('login');
    })
    .catch(err => {
      if (err.status == STATUS_FAILURE_NO_TARGET) {
        showDialog({
          message: 'urlが使用済みです。',
          status: 'failed'
        });
        return;
      }
      errorHandler(err);
    });
};

export const register = ({ mail, password, name }) => {
  ajax.post('/register', {
    method: 'register',
    password,
    mail,
    name
  })
    .then(res => {
      showDialog({
        message: 'メールアドレスに新規登録用のメールを送信しました。',
        status: 'success'
      });
      route('login')
    })
    .catch(err => {
      if (err.status == STATUS_FAILURE_TOP_EXISTSOWNER) {
        showDialog({
          message: 'すでに存在しているアカウントです。',
          status: 'failed'
        });
        return;
      }
      errorHandler(err);
    });
};

export const registerUrl = ({ key }) => {
  return ajax.post('/register', {
    method: 'registerUrl',
    key
  });
};

export const showDialog = ({ message, status }) => {
  store.setDialog({
    show: true,
    message,
    status
  });
};

export const showFailedDailog = (message) => {
  showDialog({
    message,
    status: 'failed'
  })
};

export const hideDialog = () => {
  store.setDialog({
    show: false,
    message: null,
    status: null
  });
}